import { z } from 'zod';

const photoSchema = z.object({
  small: z.string(),
  small2: z.string(),
  medium: z.string(),
  large: z.string(),
  xLarge: z.string(),
  smallWebp: z.string(),
  small2Webp: z.string(),
  mediumWebp: z.string(),
  largeWebp: z.string(),
  xLargeWebp: z.string(),
  sortOrder: z.onumber(),
  name: z.ostring(),
  id: z.onumber(),
});

const adSchema = z.object({
  photos: z.array(photoSchema).optional(),
});

export { adSchema };

export type Ad = z.infer<typeof adSchema>;
